<template>
  <ApModal v-model="modal" centered hide-header-close>
    <template #modal-title>
      {{ $t('modal.logout.title') }}
    </template>
    <template #default>
      <NotificationBadge
        class="mx-0 badge-color-notification"
        color="blue-300"
        :text="$t('modal.logout.notification')"
      >
      </NotificationBadge>
      <p class="text-base text-blue-500 mb-3 mt-3">
        {{ $t('modal.logout.content') }}
      </p>
    </template>
    <template #modal-footer>
      <ApButton @click="hide" pill variant="primary" class="px-4">{{ $t('button.ok') }}</ApButton>
    </template>
  </ApModal>
</template>

<script setup lang="ts">
import { ref, watch, onMounted } from 'vue'
import { useRoute } from 'vue-router'
// @ts-expect-error: vuex is not typped. It will be migrated to typed pinia in the future.
import { useStore } from 'vuex'
import ApModal from '@/components/widgets/ApModal.vue'
import NotificationBadge from '@/components/widgets/NotificationBadge.vue'
import ApButton from '@/components/widgets/ApButton.vue'

const modal = ref(false)
const store = useStore()
const route = useRoute()

const hide = () => {
  modal.value = false
  store.commit('auth/setForcedToLogout', false)
}

watch(
  () => route.name,
  (routeName) => {
    if (routeName === 'Login' && store.getters['auth/isForcedToLogout']) {
      modal.value = true
    }
  }
)

onMounted(() => {
  if (store.getters['auth/isForcedToLogout']) {
    modal.value = true
  }
})
</script>

<style scoped></style>
